<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qQXm08/media/FC-9798886933611.jpg?1697494195347" alt="This image is the cover for the book Memories of “A Kid from the Heights”"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memories of “A Kid from the Heights”
      </h1>
      <p class="bookDescription body article font2">
        <p style="margin: 0cm 0cm 8pt; font-size: 15px; font-family: Calibri, sans-serif;"><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>As the years go by and each step I take brings me closer to the end of my journey, coupled with the advent of isolation during the COVID-19 pandemic, I started reconnecting with many childhood friends via social media. The past two years of isolation brought the realization that this unique era we shared in a remote village during the 50s and 60s will never be available again to future generations, and that generations born after the 50s and 60s lose the likelihood of ever having an opportunity to experience this phenomenon with each passing generation.</span></p><p style="margin: 0cm 0cm 8pt; font-size: 15px; font-family: Calibri, sans-serif;"><span style='font-size:16px;font-family:"Arial Nova",sans-serif;'>With the encouragement of friends and acquaintances, I penned my <em>Memories of Being a Kid from the Heights,</em> how these experiences of ethics and morals molded our characters, and how these often comical encounters and responsibilities would benefit us while navigating life with our children. These two decades provided a lifestyle that evaporated and elapsed with each sun rotation.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Moore
      </h2>
      
      <p class="authorDescription body article"><p><span style='font-size:16px;font-family:"Times New Roman",serif;'>Born in Montreal, Don graduated from the Montreal Graphic Arts Technical Foundation in 1979 and decided to move to Nova Scotia that same year. With letter writing being the primary means of communicating with family and friends, Don began writing stories of the farming experiences he encountered. Always the storyteller, Don honed his given ability for a formal presentation of his stories.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48284763